import { Money } from '@ap/interface-bspc-core';
import { RequiredAsset, RequiredAssetDetail } from '@ap/ap-interface-apix-hypotheken-berekening';

export class RequiredAssetBuilder {
    private amount: Money;
    private detail: RequiredAssetDetail;

    withAmount(amount: Money): this {
        this.amount = amount;
        return this;
    }

    withDetail(detail: RequiredAssetDetail): this {
        this.detail = detail;
        return this;
    }

    build(): RequiredAsset {
        return {
            amount: this.amount,
            detail: this.detail
        } as RequiredAsset;
    }
}

export const aRequiredAsset = new RequiredAssetBuilder();
